import { render, staticRenderFns } from "./MovimentButtons.vue?vue&type=template&id=680c567b&"
import script from "./MovimentButtons.vue?vue&type=script&lang=js&"
export * from "./MovimentButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports